<template>
  <div class="small-6 medium-4 large-2 columns">
    <ul class="footer-contact-information">
      <li class="footer-header" v-html="contactInformationModel.AddressLabel" />
      <li>
        <p class="address">
          <span v-html="contactInformationModel.Address" /><br />
          {{ contactInformationModel.CvrLabel }}
          {{ contactInformationModel.CvrNumber }}
        </p>

        <p>
          {{ contactInformationModel.CallUsLabel }}
          <a :href="'tel:' + contactInformationModel.PhoneNumber">
            {{ contactInformationModel.PhoneNumber }}
          </a>
        </p>
      </li>
      <footer-contact-information-social-links
        :label-text="contactInformationModel.FollowUsLabel"
        :facebook-link="contactInformationModel.FacebookLink"
        :linked-in-link="contactInformationModel.LinkedInLink"
      />
    </ul>
  </div>
</template>

<script>
import FooterContactInformationSocialLinks from './FooterContactInformationSocialLinks.vue';

export default {
  name: 'FooterContactInformation',
  components: {
    FooterContactInformationSocialLinks
  },
  props: {
    contactInformationModel: {
      type: Object,
      default() {
        return {
          FacebookLink: {},
          LinkedInLink: {}
        };
      }
    }
  }
};
</script>
